import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import reportWebVitals from './reportWebVitals';
import ErrorBoundary from './Components/Dashboard/MyProfileDetails/ErrorBoundary';
import { Provider } from 'react-redux';
import { store } from './Redux/Store';

Sentry.init({
  dsn: 'https://645930233054e0f7da38c4576f72cde5@o4508504877105152.ingest.us.sentry.io/4508504885821440',
  integrations: [new BrowserTracing()],
  tracesSampleRate: 1.0,
});

if (import.meta.env?.PROD || process.env.NODE_ENV === 'production') {
  console.log = () => { };
  console.warn = () => { };
}
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store} >
      <ErrorBoundary>

        <App />

      </ErrorBoundary>
    </Provider>
  </React.StrictMode>
);

// Log performance metrics
reportWebVitals(console.log);


